import React from "react";

import { COUNTRY_FLAGS, LANGUAGES_FLAGS } from "../utils/constants";
import type { IFlag } from "../types";

import styles from "./Flags.module.scss";

export const Flag = ({ country, language, width = 30 }: IFlag) => {
  if (country && COUNTRY_FLAGS[country]) {
    return (
      <div className={styles.flag} role="presentation">
        <img
          alt={country}
          src={COUNTRY_FLAGS[country]}
          width={width}
          //@ts-ignore
          fetchpriority="low"
          data-testid="art__languageFlag"
          aria-hidden="true"
          role="presentation"
        />
      </div>
    );
  }

  if (language && LANGUAGES_FLAGS[language]) {
    return (
      <div className={styles.flag} role="presentation">
        <img
          alt={language}
          src={LANGUAGES_FLAGS[language]}
          width={width}
          //@ts-ignore
          fetchpriority="low"
          aria-hidden="true"
          role="presentation"
        />
      </div>
    );
  }

  return <></>;
};
